import FuseUtils from '@fuse/utils';
import appsConfigs from 'app/main/apps/appsConfigs';
// import ownerAppsConfigs from 'app/main/apps/ownerAppsConfigs';
import authRoleExamplesConfigs from 'app/main/auth/authRoleExamplesConfigs';
import CallbackConfig from 'app/main/callback/CallbackConfig';
import LoginConfig from 'app/main/login/LoginConfig';
import LogoutConfig from 'app/main/logout/LogoutConfig';
import pagesConfigs from 'app/main/pages/pagesConfigs';
import RegisterConfig from 'app/main/register/RegisterConfig';
import React from 'react';
import { Redirect } from 'react-router-dom';

const routeConfigs = [
	...appsConfigs,
	...pagesConfigs,
	...authRoleExamplesConfigs,
	LogoutConfig,
	LoginConfig,
	RegisterConfig,
	LogoutConfig,
	CallbackConfig,
];

const ownerRouteConfigs = [
	// ...ownerAppsConfigs,
	...pagesConfigs,
	LogoutConfig,
	LoginConfig,
	RegisterConfig,
	LogoutConfig,
	CallbackConfig
];

let isRole = null;
const userData = JSON.parse(localStorage.getItem('userData'))

if (userData && userData !== undefined && userData !== null && userData.userType) {
	isRole = userData.userType
}

const routes = [
	// if you want to make whole app auth protected by default change defaultAuth for example:
	// ...FuseUtils.generateRoutesFromConfigs(routeConfigs, ['admin','staff','user']),
	// The individual route configs which has auth option won't be overridden.
	...FuseUtils.generateRoutesFromConfigs(routeConfigs, ['Admin','user', 'Owner']),
	{
		path: "/",
		exact: true,
		component: () => <Redirect to="/dashboard" />
	},
	{
		path: '/dashboard',
		exact: true,
		component: () => <Redirect to="/dashboard" />
	},
	{
		path: '/owner/dashboard',
		exact: true,
		component: () => isRole === 'Owner' ? <Redirect to="/dashboard" /> :<Redirect to="/dashboard" />
	},
	{
		component: () => <Redirect to="/pages/errors/error-404" />,
	},
];

export default routes;
